import { default as React } from "react";
import { userRole } from "../../constant/userConfig";
import useAuthStore from "../../store/authStore";
import DataGridPrescription from "./datagrid/DataGridPrescription";
import DataGridPrescriptionViewFromAgent from "./datagrid/DataGridPrescriptionViewFromAgent";
const MedecinDashboard = () => {
  return (
    <>
      <p className="text-success h3 ">Liste des prescriptions </p>
      <DataGridPrescription />
    </>
  );
};

const AgentDashboard = () => {
  return (
    <>
      <p className="text-success h3 ">Prescriptions en attentes </p>
      <DataGridPrescriptionViewFromAgent />
    </>
  );
};

const AssuranceDashbord = () => {
  const user = useAuthStore((state) => state.user);
  const role = user ? user.role : null;
  if (role === userRole.medecin_assurance) {
    return <MedecinDashboard />;
  } else if (role == userRole.agent_assurance) {
    return <AgentDashboard />;
  } else if (role == userRole.admin_assurance) {
  }
  return (
    <div>
      <p className="h1 ">Dashboard</p>
    </div>
  );
};

export default AssuranceDashbord;
